import type { GestorDashboardFilterCriteria } from '@/components/Gestores/gestorDashboardPresetTypes'

export type CriteriaOption = { value: string; label: string }

export function resolveCriteriaWorkspaces(criteria: GestorDashboardFilterCriteria): string[] {
  if (criteria.workspaces?.length) return criteria.workspaces
  if (criteria.workspace) return [criteria.workspace]
  return []
}

export function resolveCriteriaExecutors(criteria: GestorDashboardFilterCriteria): string[] {
  if (criteria.executors?.length) return criteria.executors
  if (criteria.executor) return [criteria.executor]
  return []
}

export function normalizeCriteriaSelections(
  criteria: GestorDashboardFilterCriteria,
): GestorDashboardFilterCriteria {
  const workspaces = resolveCriteriaWorkspaces(criteria)
  const executors = resolveCriteriaExecutors(criteria)
  return {
    ...criteria,
    workspaces,
    executors,
    workspace: null,
    executor: null,
  }
}

export function matchesSelectedValues(selected: string[], value: string | null | undefined): boolean {
  if (selected.length === 0) return true
  const normalized = (value ?? '').toLowerCase()
  return selected.some((item) => item.toLowerCase() === normalized)
}
